import React from 'react'
import { ChevronArrowRightIcon } from '../../assets/icons/ChevronArrowRightIcon'
import { getMergedClassNames } from '../../utils/HTMLutils'
import './BreadCrumb.scss'
const rootClassName = 'component-bread-crumb'

interface BreadCrumbProps {
  path: {
    label: string
    onClick?: () => void
  }[]
}

export default function BreadCrumb(props: BreadCrumbProps) {
  return (
    <div className={rootClassName}>
      {props.path && props.path.length
        ? props.path.map((p, index) => {
            return (
              <div
                key={index}
                className={getMergedClassNames([
                  `${rootClassName}-path`,
                  p.onClick && typeof p.onClick === 'function'
                    ? `${rootClassName}-active`
                    : ''
                ])}
                onClick={p.onClick}
              >
                {index > 0 ? (
                  <div className={`${rootClassName}-arrow`}>
                    <ChevronArrowRightIcon />
                  </div>
                ) : undefined}
                <div className={`${rootClassName}-label nunito`}>{p.label}</div>
              </div>
            )
          })
        : undefined}
    </div>
  )
}

BreadCrumb.defaultProps = {
  path: []
}
